/**
 *
 * Button
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import styled from 'styled-components';

const Label = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
`;

const IconContainer = styled.div`
  width: 1px;
  margin: 0 16px 0 -16px;
`;

const ButtonWrapper = styled.div`
  cursor: ${props => (props?.disabled ? 'not-allowed' : 'pointer')};
`;

/* eslint-disable react/prefer-stateless-function */
export class Button extends React.PureComponent {
  onClick(evt) {
    if (!this.props.onClick) return;
    evt.preventDefault();
    evt.stopPropagation();
    this.props.onClick(evt);
    return false;
  }

  render() {
    let classes = 'button labeled ';
    if (this.props.primary || this.props.isPrimary) classes += 'primary ';
    if (this.props.upload) classes += 'upload ';
    if (this.props.className) classes += ` ${this.props.className} `;
    if (this.props.disabled) classes += 'disabled ';
    if (this.props.small) classes += 'small ';
    if (this.props.inline) classes += 'inline ';
    if (this.props.block) classes += 'block';
    if (this.props.warning) classes += 'warning';
    if (this.props.select) classes += 'select';

    let onClick = this.props.disabled ? null : this.onClick.bind(this);

    return (
      <ButtonWrapper onClick={onClick} className={classes} disabled={this.props.disabled}>
        {this.renderIcon()}
        <Label>{this.props.children}</Label>
      </ButtonWrapper>
    );
  }

  renderIcon() {
    if (!this.props.icon) return null;
    let C = this.props.icon;
    return (
      <IconContainer>
        <C />
      </IconContainer>
    );
  }
}

Button.propTypes = {
  isPrimary: PropTypes.bool,
  onClick: PropTypes.func,
};
